import React, { useEffect, useState } from "react";
import axios from "axios";
const AboutUs = () => {
  // const [aboutUs, setAboutUs] = useState({});
  // const [loading, setLoading] = useState(true);
  // const [aboutUs, setAboutUs] = useState("");
  // useEffect(() => {
  //   // Declare an async function inside the useEffect
  //   const fetchData = async () => {
  //     setLoading(true);
  //     try {
  //       const response = await axios.get(
  //         "https://strapi-z1jg.onrender.com/api/about-uses",
  //         {
  //           headers: {
  //             Authorization:
  //               "Bearer f8cbe15ca5f9b30d8106fdc417071c13d0839065d6fb779c920670ee26cd8c01bc8e9b3b4e803dafc3671601772e30fa425fbdc9880eb098a41b267fcd708491460822c68399b1f550828c34757bc3bcba671bd4df025111357d89d3ea7af051a850c76fa6532a31e3133a87e0f35c4cc49602632c77d3569ccf2e11d8810e69",
  //           },
  //         }
  //       );
  //       setAboutUs(response.data.data[0].attributes.Content); // Set the state with the response data
  //       console.log(response.data)

  //     } catch (error) {
  //       console.error("Error fetching data: ", error);
  //     }
  //     setLoading(false);
  //   };

  //   fetchData(); // Call the async function
  // }, []);
  // if (loading) {
  //   return <div>Loading....</div>;
  // }
  return (
    <div id="about-us" className="py-[50px] dark:bg-dark">
      <h1 className="text-[60px] dark:text-light text-[#451644] px-2 lg:px-28  leading-normal font-bold font-mono">
        About Us
      </h1>
      <div className="flex flex-col md:flex-row gap-10 my-[50px] w-full px-[30px] lg:px-0 lg:w-[80%] mx-auto items-center justify-between dark:text-white">
        <div className="flex text-[16px] font-sans flex-col w-full px-2 md:px-0 md:w-[45%] items-start justify-center gap-2 relative">
          <div
            style={{
              position: "absolute",
              width: "372.95px",
              height: "357.05px",
              left: "calc(50% - 372.95px/2 - 76.53px)",
              top: "calc(50% - 307.05px/2 - 47.47px)",

              // background: mode !== 'dark'  ? "linear-gradient(123.77deg, #8A2BE2 -6.46%, #FFA500 59.04%, #F8F8FF 124.53%)": "linear-gradient(118.19deg, #1FA2FF -3.62%, #12D8FA 50.44%, #A6FFCB 104.51%)",
              background:
                "linear-gradient(118.19deg, #1FA2FF -3.62%, #12D8FA 50.44%, #A6FFCB 104.51%)",
              opacity: 0.2,
              filter: "blur(34px)",
              transform: "matrix(1, 0, -0.03, 1, 0, 0)",

              /* Inside auto layout */

              flex: "none",
              order: "0",
              flexGrow: "0",
              zIndex: "0",
              borderRadius: "50%",
            }}
          ></div>
          {/* <p>{aboutUs.para1}</p> */}
          <p>
            We help clients redefine what their future looks like through
            technology. This is delivered through strategic thinking, tactical
            skills and IP tools, so you can more easily adopt and benefit from
            innovation. {/* {aboutUs.para2} */}
          </p>
          <p>
            Our team of technology and business experts help clients to overcome
            challenges and prepare for the future. We offer proven practices,
            honed from thousands of technology deployments across dozens of
            industries, resulting in effective and practical, end-to-end
            outcomes. {/* {aboutUs.para3} */}
          </p>
          {/* <p>{aboutUs.para4}</p>
          <p className="text-[#451644] dark:text-white font-bold">
            {aboutUs.para5}
          </p> */}
        </div>
        <div className="w-full relative px-2 md:px-0  md:w-[45%]">
          <iframe
            width="100%"
            height="300px"
            src="https://www.youtube.com/embed/MZLHwf8a63o"
            title="JavaScript for Beginners: Introduction, Features, and First Code | Episode 1"
            frameBorder="0"
            className="shadow-lg dark:shadow-dimWhite shadow-dark"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
